import { useNavigate } from "react-router-dom";

import { useRandomSigninBackgroundImage } from "@/Helpers/randomBackgroundImage";
import { AuthenticationSignIn } from "@/Shared/Authentication/CustomComponents/AuthenticationSignIn";
import { AuthenticationScreenContainer } from "./CustomComponents/AuthenticationScreenContainer";

function SignInScreen() {
  const navigate = useNavigate();
  const backgroundImage = useRandomSigninBackgroundImage();

  function onCreateAccountInstead() {
    navigate("/create-account");
  }

  function onForgotPassword() {
    navigate("/request-reset-password");
  }

  return (
    <AuthenticationScreenContainer imageUrl={backgroundImage}>
      <AuthenticationSignIn
        onCreateAccountInstead={onCreateAccountInstead}
        onForgotPassword={onForgotPassword}
        redirectAfterSignin={true}
        onSuccess={() => {}}
      />
    </AuthenticationScreenContainer>
  );
}
export default SignInScreen;
